var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('img',{staticClass:"mx-auto h-6",attrs:{"src":require("../assets/images/mip.svg")}})])}]

export { render, staticRenderFns }